import { render, staticRenderFns } from "./FabButton.vue?vue&type=template&id=078588a4"
import script from "./FabButton.vue?vue&type=script&lang=js"
export * from "./FabButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports